/**
 * 埋点配置：配置表路由优先，本地目录在配置接口不可用时兜底
 */

import { listTrackRoutes } from '@/api/trackConfig.js'

/** path 前缀 → { moduleCode, pageCode }，按前缀长度降序匹配 */
export const TRACK_ROUTE_MAP = [
  // planFlow
  { prefix: '/planFlow/customerCluesThree', moduleCode: 'customer_clue_three', pageCode: 'clue_list_three' },
  { prefix: '/planFlow/customerClues', moduleCode: 'customer_clue', pageCode: 'clue_list' },
  { prefix: '/planFlow/customerFollow', moduleCode: 'customer_follow', pageCode: 'follow_list' },
  { prefix: '/planFlow/purposeProject', moduleCode: 'purpose_project', pageCode: 'project_list' },
  { prefix: '/planFlow/omicsPlan', moduleCode: 'omics_plan', pageCode: 'omis_plan_list' },
  { prefix: '/planFlow/customAntibodyPlan', moduleCode: 'custom_antibody_plan', pageCode: 'cutm_anti_plan_list' },
  { prefix: '/planFlow/cuttagPlan', moduleCode: 'cuttag_antibody', pageCode: 'cuttag_plan' },
  { prefix: '/planFlow/salesBattleMaps', moduleCode: 'battle_map_panorama', pageCode: 'battle_map_list' },
  // 作战地图分析子页（具体 path 优先于 /planFlow/battleMapReport 兜底）
  { prefix: '/planFlow/battleMapReport/reportList2', moduleCode: 'battle_map_panorama', pageCode: 'battle_map_report' },
  { prefix: '/planFlow/battleMapReport/reportList3', moduleCode: 'battle_map_panorama', pageCode: 'battle_map_customer_amount' },
  { prefix: '/planFlow/battleMapReport/reportList4', moduleCode: 'battle_map_panorama', pageCode: 'battle_map_customer_quantity' },
  { prefix: '/planFlow/battleMapReport/reportList5', moduleCode: 'battle_map_panorama', pageCode: 'battle_map_three_products' },
  { prefix: '/planFlow/battleMapReport', moduleCode: 'battle_map_panorama', pageCode: 'battle_map_report' },

  // cutTag（具体页面优先于 /cutTag 兜底）
  { prefix: '/cutTag/sample/noticeInfo', moduleCode: 'cuttag_antibody', pageCode: 'cuttag_notice_info' },
  { prefix: '/cutTag/sample/sampleSheetList', moduleCode: 'cuttag_antibody', pageCode: 'cuttag_sample_sheet_list' },
  { prefix: '/cutTag/qcr/qcrList', moduleCode: 'cuttag_antibody', pageCode: 'cuttag_qcr_list' },
  { prefix: '/cutTag/qcrBack/qcrBackList', moduleCode: 'cuttag_antibody', pageCode: 'cuttag_qcr_back_list' },
  { prefix: '/cutTag/project/projectFinishList', moduleCode: 'cuttag_antibody', pageCode: 'cuttag_project_finish_list' },
  { prefix: '/cutTag/project/projectList', moduleCode: 'cuttag_antibody', pageCode: 'cuttag_project_list' },
  { prefix: '/cutTag', moduleCode: 'cuttag_antibody', pageCode: 'cuttag_page' },

  // 项目管理
  { prefix: '/modules/projectManage/projectCheck', moduleCode: 'delivery_accept', pageCode: 'delivery_accept_check' },
  { prefix: '/modules/projectManage/projectManage', moduleCode: 'project_start', pageCode: 'project_start_list' },
  // 首页「项目验收」入口实际是 projectFinish 列表，归入交付验收
  { prefix: '/modules/projectManage/projectFinish', moduleCode: 'delivery_accept', pageCode: 'delivery_accept_list' },
  { prefix: '/modules/projectManage/projectShareFinish', moduleCode: 'delivery_accept', pageCode: 'delivery_accept_list' },
  { prefix: '/modules/projectManage/shareManage', moduleCode: 'share_manage', pageCode: 'share_manage_list' },
  { prefix: '/modules/bigProjectManage', moduleCode: 'big_project', pageCode: 'big_project_list' },

  // 质检 / 订单 / 工单
  { prefix: '/modules/qcr', moduleCode: 'qcr_manage', pageCode: 'qcr_list' },
  { prefix: '/modules/zhijianfankui', moduleCode: 'zhijian_feedback', pageCode: 'zhijian_manage' },
  { prefix: '/modules/dingdanchaifen', moduleCode: 'order_split', pageCode: 'dingdanchaifen_list' },
  { prefix: '/modules/lxspgl', moduleCode: 'lxspgl', pageCode: 'lxspgl_list' },
  { prefix: '/modules/lshtbg', moduleCode: 'lshtbg', pageCode: 'lshtbg_list' },
  { prefix: '/modules/ticket', moduleCode: 'ticket', pageCode: 'ticket_list' },
  // 送检单：具体页面优先于 /modules/songjiandan 兜底
  { prefix: '/modules/songjiandan/songjiandan-manage', moduleCode: 'sample_sheet', pageCode: 'sample_sheet_list' },
  { prefix: '/modules/songjiandan/txsjd', moduleCode: 'sample_sheet', pageCode: 'sample_sheet_fill' },
  { prefix: '/modules/songjiandan', moduleCode: 'sample_sheet', pageCode: 'sample_sheet_list' },

  // 技术交互管理（一期）
  { prefix: '/modules/afterSale/mutual', moduleCode: 'tech_interact_project', pageCode: 'tech_interact_mutual' },
  { prefix: '/modules/afterSale/manage', moduleCode: 'tech_interact_project', pageCode: 'tech_interact_manage' },
  { prefix: '/modules/afterSale/urgent', moduleCode: 'tech_interact_project', pageCode: 'tech_interact_urgent' },
  // 首页快捷入口父路径（zhuceHome/systemHome 使用 /afterSales）
  { prefix: '/afterSales', moduleCode: 'tech_interact_project', pageCode: 'tech_interact_manage' },
  // 项目交互管理流程子页（otherRouter 短路径，归入管理页统计）
  { prefix: '/needRate', moduleCode: 'tech_interact_project', pageCode: 'tech_interact_manage' },
  { prefix: '/taskHandle', moduleCode: 'tech_interact_project', pageCode: 'tech_interact_manage' },
  { prefix: '/taskFeedback', moduleCode: 'tech_interact_project', pageCode: 'tech_interact_manage' },
  { prefix: '/customConfirm', moduleCode: 'tech_interact_project', pageCode: 'tech_interact_manage' },
  { prefix: '/taskProcess', moduleCode: 'tech_interact_project', pageCode: 'tech_interact_manage' },
  { prefix: '/downloadCheck', moduleCode: 'tech_interact_project', pageCode: 'tech_interact_manage' },
  { prefix: '/afterSaleEvaluate', moduleCode: 'tech_interact_project', pageCode: 'tech_interact_manage' },

  // 组学售后（新版菜单页，具体 path 优先于 aftersale 兜底）
  { prefix: '/modules/afterSale/aftersale/applyHome', moduleCode: 'omics_aftersale', pageCode: 'apply_home' },
  { prefix: '/modules/afterSale/aftersale/applyList', moduleCode: 'omics_aftersale', pageCode: 'apply_list' },
  { prefix: '/modules/afterSale/aftersale/workOrderList', moduleCode: 'omics_aftersale', pageCode: 'work_order_list' },
  { prefix: '/modules/afterSale/aftersale/assignList', moduleCode: 'omics_aftersale', pageCode: 'assign_list' },
  { prefix: '/modules/afterSale/aftersale/bigProjectList', moduleCode: 'omics_aftersale', pageCode: 'as_big_project_list' },
  { prefix: '/modules/afterSale/aftersale/statsDashboard', moduleCode: 'omics_aftersale', pageCode: 'as_stats_dashboard' },
  { prefix: '/modules/afterSale/aftersale', moduleCode: 'omics_aftersale', pageCode: 'omics_aftersale_page' },

  // 组学售后（独立短路由，见 otherRouter.js）
  { prefix: '/asApplyForm', moduleCode: 'omics_aftersale', pageCode: 'apply_form' },
  { prefix: '/asApplyDetail', moduleCode: 'omics_aftersale', pageCode: 'apply_detail' },
  { prefix: '/asApplyAudit', moduleCode: 'omics_aftersale', pageCode: 'apply_audit' },
  { prefix: '/asAssignDetail', moduleCode: 'omics_aftersale', pageCode: 'assign_detail' },
  { prefix: '/asWorkOrderDetail', moduleCode: 'omics_aftersale', pageCode: 'work_order_detail' },
  { prefix: '/asSatisfactionSubmit', moduleCode: 'omics_aftersale', pageCode: 'satisfaction_submit' },
  { prefix: '/asApplyProgress', moduleCode: 'omics_aftersale', pageCode: 'apply_progress' },
  { prefix: '/asStatsDashboard', moduleCode: 'omics_aftersale', pageCode: 'as_stats_dashboard' },

  // 应收回款（菜单 url 通常对应 views 路径）
  {
    prefix: '/receivableManage/receivable/receivableManagement',
    moduleCode: 'receivable_manage',
    pageCode: 'receivable_list'
  },
  {
    prefix: '/receivableManage/receivable/receivableList',
    moduleCode: 'receivable_manage',
    pageCode: 'receivable_list'
  },
  { prefix: '/receivableManage/receivable', moduleCode: 'receivable_manage', pageCode: 'receivable_list' },
  { prefix: '/receivableManage', moduleCode: 'receivable_manage', pageCode: 'receivable_list' }
]

TRACK_ROUTE_MAP.sort((a, b) => b.prefix.length - a.prefix.length)

const CONFIGURED_ROUTE_TTL_MS = 30000

/** 配置表路由，前缀长的在前 */
let configuredRoutes = []
let configuredLoadedAt = 0
let configuredLoading = null

export function setConfiguredRoutes(rows) {
  const list = []
  if (rows && rows.length) {
    for (let i = 0; i < rows.length; i++) {
      const row = rows[i]
      if (!row || !row.routePath || !row.moduleCode || !row.pageCode) continue
      list.push({
        prefix: row.routePath,
        moduleCode: row.moduleCode,
        pageCode: row.pageCode
      })
    }
  }
  list.sort((a, b) => b.prefix.length - a.prefix.length)
  configuredRoutes = list
  configuredLoadedAt = Date.now()
}

export function getConfiguredRoutes() {
  return configuredRoutes
}

/** 拉取配置表路由。30 秒内复用缓存；失败时沿用上一次结果。 */
export function ensureConfiguredRoutes() {
  if (configuredLoadedAt && Date.now() - configuredLoadedAt < CONFIGURED_ROUTE_TTL_MS) {
    return Promise.resolve(configuredRoutes)
  }
  if (configuredLoading) return configuredLoading
  configuredLoading = listTrackRoutes()
    .then(function (res) {
      const data = res && res.data
      setConfiguredRoutes(Array.isArray(data) ? data : [])
      return configuredRoutes
    })
    .catch(function () {
      configuredLoadedAt = Date.now()
      return configuredRoutes
    })
    .then(function (routes) {
      configuredLoading = null
      return routes
    })
  return configuredLoading
}

function matchRouteMap(routes, normalized) {
  for (let i = 0; i < routes.length; i++) {
    const item = routes[i]
    const prefix = item.prefix
    if (normalized === prefix || normalized.indexOf(prefix + '/') === 0) {
      return { moduleCode: item.moduleCode, pageCode: item.pageCode }
    }
  }
  return null
}

/**
 * path → { moduleCode, pageCode }，最长前缀匹配
 * @param {string} path
 * @returns {{ moduleCode: string, pageCode: string } | null}
 */
export function resolveRouteByPath(path) {
  if (!path) return null
  let normalized = String(path)
  const hashIdx = normalized.indexOf('#')
  if (hashIdx >= 0) {
    normalized = normalized.substring(0, hashIdx)
  }
  const qIdx = normalized.indexOf('?')
  if (qIdx >= 0) {
    normalized = normalized.substring(0, qIdx)
  }
  normalized = normalized.trim()
  if (!normalized) return null
  if (normalized.charAt(0) !== '/') {
    normalized = '/' + normalized
  }
  // 去掉末尾 /
  while (normalized.length > 1 && normalized.charAt(normalized.length - 1) === '/') {
    normalized = normalized.substring(0, normalized.length - 1)
  }
  return matchRouteMap(configuredRoutes, normalized) || matchRouteMap(TRACK_ROUTE_MAP, normalized)
}

/**
 * 看板/明细筛选树：一级按业务菜单分组，二级为具体页面
 * 叶子带真实落库编码 moduleCode / pageCode（一级 value 仅作分组，不落库）
 */
export const TRACK_MODULE_CASCADE = [
  {
    value: 'menu_battle_map',
    label: '作战地图全景图',
    children: [
      { value: 'battle_map_list', label: '销售作战地图列表', moduleCode: 'battle_map_panorama', pageCode: 'battle_map_list' },
      { value: 'battle_map_report', label: '作战地图分析', moduleCode: 'battle_map_panorama', pageCode: 'battle_map_report' },
      { value: 'battle_map_customer_amount', label: '客户金额分析', moduleCode: 'battle_map_panorama', pageCode: 'battle_map_customer_amount' },
      { value: 'battle_map_customer_quantity', label: '客户数量分析', moduleCode: 'battle_map_panorama', pageCode: 'battle_map_customer_quantity' },
      { value: 'battle_map_three_products', label: '三大产品+大项目', moduleCode: 'battle_map_panorama', pageCode: 'battle_map_three_products' },
      { value: 'clue_list', label: '线索-田里的', moduleCode: 'customer_clue', pageCode: 'clue_list' },
      { value: 'follow_list', label: '客户跟进管理', moduleCode: 'customer_follow', pageCode: 'follow_list' },
      { value: 'project_list', label: '意向-立项', moduleCode: 'purpose_project', pageCode: 'project_list' },
      { value: 'omis_plan_list', label: '意向-计划流', moduleCode: 'omics_plan', pageCode: 'omis_plan_list' },
      { value: 'clue_list_three', label: '意向-转化', moduleCode: 'customer_clue_three', pageCode: 'clue_list_three' },
      { value: 'cutm_anti_plan_list', label: '意向-定制抗体', moduleCode: 'custom_antibody_plan', pageCode: 'cutm_anti_plan_list' },
      { value: 'cuttag_plan', label: '意向-CUT&TAG', moduleCode: 'cuttag_antibody', pageCode: 'cuttag_plan' }
    ]
  },
  {
    value: 'menu_sample_sheet',
    label: '送检单管理',
    children: [
      { value: 'sample_sheet_fill', label: '填写送检单', moduleCode: 'sample_sheet', pageCode: 'sample_sheet_fill' },
      { value: 'sample_sheet_list', label: '送检单管理', moduleCode: 'sample_sheet', pageCode: 'sample_sheet_list' }
    ]
  },
  {
    value: 'menu_project_start',
    label: '项目启动',
    children: [
      { value: 'project_start_list', label: '项目管理', moduleCode: 'project_start', pageCode: 'project_start_list' },
      { value: 'qcr_list', label: '质控报告管理', moduleCode: 'qcr_manage', pageCode: 'qcr_list' },
      { value: 'zhijian_manage', label: '质检反馈管理', moduleCode: 'zhijian_feedback', pageCode: 'zhijian_manage' },
      { value: 'dingdanchaifen_list', label: '订单拆分确认', moduleCode: 'order_split', pageCode: 'dingdanchaifen_list' },
      { value: 'lxspgl_list', label: '立项审批管理', moduleCode: 'lxspgl', pageCode: 'lxspgl_list' },
      { value: 'lshtbg_list', label: '历史合同变更', moduleCode: 'lshtbg', pageCode: 'lshtbg_list' },
      { value: 'ticket_list', label: '开票计划确认', moduleCode: 'ticket', pageCode: 'ticket_list' }
    ]
  },
  {
    value: 'menu_delivery_accept',
    label: '交付验收',
    children: [
      { value: 'delivery_accept_list', label: '项目验收', moduleCode: 'delivery_accept', pageCode: 'delivery_accept_list' },
      { value: 'delivery_accept_check', label: '项目验收流程', moduleCode: 'delivery_accept', pageCode: 'delivery_accept_check' }
    ]
  },
  {
    value: 'menu_project_other',
    label: '项目相关其他',
    children: [
      { value: 'big_project_list', label: '大项目学术经理管理', moduleCode: 'big_project', pageCode: 'big_project_list' }
    ]
  },
  {
    value: 'menu_cuttag',
    label: '抗体',
    children: [
      { value: 'cuttag_notice_info', label: '填写送检单须知', moduleCode: 'cuttag_antibody', pageCode: 'cuttag_notice_info' },
      { value: 'cuttag_sample_sheet_list', label: 'CUT&Tag送检单管理', moduleCode: 'cuttag_antibody', pageCode: 'cuttag_sample_sheet_list' },
      { value: 'cuttag_qcr_list', label: 'CUT&Tag质控报告', moduleCode: 'cuttag_antibody', pageCode: 'cuttag_qcr_list' },
      { value: 'cuttag_qcr_back_list', label: 'CUT&Tag质检反馈', moduleCode: 'cuttag_antibody', pageCode: 'cuttag_qcr_back_list' },
      { value: 'cuttag_project_list', label: '抗体项目管理', moduleCode: 'cuttag_antibody', pageCode: 'cuttag_project_list' },
      { value: 'cuttag_project_finish_list', label: 'CUT&Tag交付验收', moduleCode: 'cuttag_antibody', pageCode: 'cuttag_project_finish_list' },
      { value: 'cuttag_page', label: 'CUT&Tag其他页', moduleCode: 'cuttag_antibody', pageCode: 'cuttag_page' }
    ]
  },
  {
    value: 'menu_tech_interact',
    label: '技术交互管理',
    children: [
      { value: 'tech_interact_mutual', label: '技术交互申请', moduleCode: 'tech_interact_project', pageCode: 'tech_interact_mutual' },
      { value: 'tech_interact_manage', label: '技术交互管理', moduleCode: 'tech_interact_project', pageCode: 'tech_interact_manage' },
      // 菜单名「项目交互管理」→ /modules/projectManage/shareManage（非 projectManage 列表）
      { value: 'share_manage_list', label: '项目交互管理', moduleCode: 'share_manage', pageCode: 'share_manage_list' },
      { value: 'tech_interact_urgent', label: '加急申请管理', moduleCode: 'tech_interact_project', pageCode: 'tech_interact_urgent' }
    ]
  },
  {
    value: 'menu_omics_aftersale',
    label: '组学售后管理',
    children: [
      { value: 'apply_home', label: '售后申请首页', moduleCode: 'omics_aftersale', pageCode: 'apply_home' },
      { value: 'apply_list', label: '售后申请列表', moduleCode: 'omics_aftersale', pageCode: 'apply_list' },
      { value: 'apply_form', label: '新建/编辑申请', moduleCode: 'omics_aftersale', pageCode: 'apply_form' },
      { value: 'apply_detail', label: '申请详情', moduleCode: 'omics_aftersale', pageCode: 'apply_detail' },
      { value: 'apply_audit', label: '申请审批', moduleCode: 'omics_aftersale', pageCode: 'apply_audit' },
      { value: 'apply_progress', label: '申请进展', moduleCode: 'omics_aftersale', pageCode: 'apply_progress' },
      { value: 'assign_list', label: '分配列表', moduleCode: 'omics_aftersale', pageCode: 'assign_list' },
      { value: 'assign_detail', label: '分配详情', moduleCode: 'omics_aftersale', pageCode: 'assign_detail' },
      { value: 'work_order_list', label: '工单处理列表', moduleCode: 'omics_aftersale', pageCode: 'work_order_list' },
      { value: 'work_order_detail', label: '工单详情', moduleCode: 'omics_aftersale', pageCode: 'work_order_detail' },
      { value: 'satisfaction_submit', label: '满意度评价', moduleCode: 'omics_aftersale', pageCode: 'satisfaction_submit' },
      { value: 'as_big_project_list', label: '大项目维护', moduleCode: 'omics_aftersale', pageCode: 'as_big_project_list' }
    ]
  },
  {
    value: 'menu_receivable',
    label: '应收回款',
    children: [
      {
        value: 'receivable_list',
        label: '应收回款',
        moduleCode: 'receivable_manage',
        pageCode: 'receivable_list'
      }
    ]
  }
]

/** 真实 moduleCode → 中文名（看板图表/列表展示用，与侧栏菜单父级对齐） */
export const TRACK_MODULE_LABEL_MAP = {
  battle_map_panorama: '作战地图全景图',
  customer_clue: '线索-田里的',
  customer_follow: '客户跟进管理',
  purpose_project: '意向-立项',
  omics_plan: '意向-计划流',
  customer_clue_three: '意向-转化',
  custom_antibody_plan: '意向-定制抗体',
  sample_sheet: '送检单管理',
  project_start: '项目启动',
  qcr_manage: '质控报告管理',
  zhijian_feedback: '质检反馈管理',
  order_split: '订单拆分确认',
  lxspgl: '立项审批管理',
  lshtbg: '历史合同变更',
  ticket: '开票计划确认',
  delivery_accept: '交付验收',
  big_project: '大项目学术经理管理',
  // 历史数据兼容：曾误绑 projectFinish
  project_finish: '交付验收',
  share_manage: '共享项目管理',
  cuttag_antibody: '抗体',
  tech_interact_project: '技术交互管理',
  omics_aftersale: '组学售后管理',
  receivable_manage: '应收回款'
}

/** 一级下拉（兼容旧用法） */
export const TRACK_MODULE_OPTIONS = TRACK_MODULE_CASCADE.map(function (m) {
  return { value: m.value, label: m.label }
})

/** pageCode → 中文名 */
export const TRACK_PAGE_LABEL_MAP = TRACK_MODULE_CASCADE.reduce(function (acc, m) {
  if (m.children) {
    m.children.forEach(function (p) {
      acc[p.pageCode || p.value] = p.label
    })
  }
  return acc
}, {})

// 与 /index/userMenus 菜单名对齐（pageCode → 菜单 C 节点名）
TRACK_PAGE_LABEL_MAP.tech_interact_mutual = '技术交互申请'
TRACK_PAGE_LABEL_MAP.tech_interact_manage = '技术交互管理'
TRACK_PAGE_LABEL_MAP.share_manage_list = '项目交互管理'
TRACK_PAGE_LABEL_MAP.tech_interact_urgent = '加急申请管理'
TRACK_PAGE_LABEL_MAP.project_start_list = '项目管理'

// 历史编码兼容（路由改绑后旧数据仍能展示中文）
TRACK_PAGE_LABEL_MAP.project_finish_list = TRACK_PAGE_LABEL_MAP.project_finish_list || '项目验收'
TRACK_PAGE_LABEL_MAP.omics_aftersale_page = TRACK_PAGE_LABEL_MAP.omics_aftersale_page || '组学售后其他页'

/** 事件类型 → 中文（下拉/列表展示；请求仍传英文编码） */
export const TRACK_EVENT_TYPE_LABEL_MAP = {
  click: '点击',
  search: '搜索'
}

export const TRACK_EVENT_TYPE_OPTIONS = [
  { value: 'click', label: '点击' },
  { value: 'search', label: '搜索' }
]

/** 常用按钮编码 → 中文（无映射时回退按钮名称） */
export const TRACK_BUTTON_CODE_LABEL_MAP = {
  search: '搜索',
  reset: '重置',
  create: '新建',
  edit: '编辑',
  export: '导出',
  refresh: '刷新',
  submit: '提交',
  reject: '驳回',
  stop: '终止',
  copy: '复制',
  detail: '详情',
  view: '查看',
  back: '返回',
  next: '下一步',
  save: '保存',
  cancel: '取消',
  download: '下载',
  import_update: '更新导入',
  export_template: '模板导出',
  approval: '审批',
  check_point: '销售机会点立项check点',
  assign: '分配',
  process: '处理',
  audit: '审批处理',
  evaluate: '评价',
  save_draft: '存草稿',
  submit_continue: '提交并继续新建',
  submit_stage: '提交阶段',
  accept_ms: '承接质谱',
  reassign: '指派他人',
  rollback: '回退',
  download_result: '结果下载',
  view_all: '查看全部',
  draft: '草稿箱',
  stats: '数据统计',
  remove: '删除',
  push_contract: '推送销售合同',
  intention_project: '意向-立项',
  change_sales: '变更负责销售',
  changeSales: '变更负责销售',
  risk_label: '风险标签',
  riskClick: '风险标签',
  urgent: '加急申请',
  update_eta: '更新预计完成时间',
  view_result: '查看结果',
  accept: '确认验收',
  confirm: '确认',
  close: '关闭',
  prev: '上一步',
  view_confirm: '查看项目确认单',
  maintain: '维护应收回款',
  change_log: '变更日志'
}

/**
 * @param {string} pageCode
 */
export function formatTrackPageLabel(pageCode) {
  if (!pageCode) return '-'
  return TRACK_PAGE_LABEL_MAP[pageCode] || pageCode
}

/**
 * 优先展示入库的按钮中文名（与页面文案一致），无名称时再回退 code 映射。
 * @param {string} code
 * @param {string} [fallbackName]
 */
export function formatTrackButtonCode(code, fallbackName) {
  if (fallbackName) return fallbackName
  if (!code) return '-'
  return TRACK_BUTTON_CODE_LABEL_MAP[code] || code
}

/**
 * @param {string} eventType
 */
export function formatTrackEventType(eventType) {
  if (eventType == null || eventType === '') return '-'
  return TRACK_EVENT_TYPE_LABEL_MAP[eventType] || eventType
}

/**
 * 级联选中值 → 查询参数
 * 沿选中路径遍历级联树，取最后一个带 moduleCode/pageCode 的节点。
 * 仅选目录时不带筛选条件。
 * @param {string[]} value
 * @param {Array} [cascadeOptions]
 * @returns {{ moduleCode?: string, pageCode?: string }}
 */
export function cascadeToQuery(value, cascadeOptions) {
  if (!value || !value.length) {
    return { moduleCode: undefined, pageCode: undefined }
  }
  const options = cascadeOptions || TRACK_MODULE_CASCADE
  let nodes = options
  let lastTracked = null

  for (let i = 0; i < value.length; i++) {
    const node = nodes.find(function (item) {
      return item.value === value[i]
    })
    if (!node) break
    if (node.moduleCode || node.pageCode) {
      lastTracked = node
    }
    nodes = node.children || []
  }

  if (!lastTracked) {
    return { moduleCode: undefined, pageCode: undefined }
  }
  // 禁止用 cascader value（菜单 menuId）回退为 pageCode，否则会筛出空结果
  return {
    moduleCode: lastTracked.moduleCode || undefined,
    pageCode: lastTracked.pageCode || undefined
  }
}



// WEBPACK FOOTER //
// ./src/utils/track/trackConfig.js